import React from "react";
import { IVariant } from "../../../../../services/model/Product";

interface Props {
    variant: IVariant;
}

const Variant: React.FC<Props> = (props) => {
    // Determine opacity based on availability
    const contentOpacity = props.variant.isAvailable ? 1 : 0.6;

    return (
        <div className="mb-4">
            <div className="d-flex align-items-center">
                {/* 1. Name: Dimmed if OOS + Strike-through */}
                <h5
                    className={`mb-0 ${!props.variant.isAvailable ? 'text-decoration-line-through' : ''}`}
                    style={{
                        fontWeight: props.variant.isAvailable ? 'bold' : 'normal',
                        opacity: contentOpacity
                    }}
                >
                    {props.variant.name}
                </h5>

                {/* 2. Badge: ALWAYS 1.0 Opacity (High Visibility) */}
                {!props.variant.isAvailable && (
                    <span
                        className="ms-2 badge border border-danger"
                        style={{
                            fontSize: '0.7rem',
                            backgroundColor: 'transparent',
                            color: '#ff0000',
                            fontWeight: '900',
                            opacity: 1 // Explicitly full brightness
                        }}
                    >
                       OPTION OUT OF STOCK
                    </span>
                )}
            </div>

            <div className="mt-2">
                {/* 3. Price: Dimmed if OOS */}
                <span className="h4 me-2" style={{ opacity: contentOpacity }}>
                    ${props.variant.price.toFixed(2)}
                </span>
            </div>
        </div>
    );
};

export default Variant;